/**
 * Contract Status Catalog Hook
 */

import { useState, useEffect } from 'react';
import { contractCatalogService } from '../contract.service.ts';
import type { ContractStatus } from '../contract.types.ts';


interface UseContractStatusesResult {
  statuses: ContractStatus[];
  loading: boolean;
  error: string | null;
}

export function useContractStatuses(): UseContractStatusesResult {
  const [statuses, setStatuses] = useState<ContractStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await contractCatalogService.getStatuses();

        if (!isMounted) return;

        if (response.success && response.data) {
          setStatuses(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading contract statuses');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { statuses, loading, error };
}
